module.exports = __webpack_public_path__ + "img/map1.5af4a212.png";